import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const env = process.env.REACT_APP_ENV;
console.log("====>ENV NEW", env);
const API_BASE_URL =
  env === "production"
    ? "https://hello-gorgeous.shop/api/v1"
    : "https://dev.hello-gorgeous.shop/api/v1";

const WEBSITE =
  env === "production"
    ? "https://hello-gorgeous.shop"
    : "https://dev.hello-gorgeous.shop";
export const getCartApi = async (userId, token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/carts/cart/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch Error:", error);
    throw error;
  }
};

const CheckoutForm = () => {
  const [transactionData, setTransactionData] = useState({
    orderId: null,
    signature: "",
    txnAmount: null,
    userEmail: null,
    userPhone: null,
    cartItems: [],
    txnDate: null,
  });

  const location = useLocation();
  useEffect(() => {
    const fetchTransactionData = async () => {
      const queryParams = new URLSearchParams(location.search);
      if (queryParams.size > 0) {
        const userId = queryParams.get("userId");
        const token = queryParams.get("token");
        let cartItems = [];

        if (userId) {
          try {
            cartItems = await getCartApi(userId, token);
          } catch (error) {
            console.error("Error fetching cart items:", error);
          }
        }

        setTransactionData({
          orderId: queryParams.get("orderId"),
          signature: queryParams.get("signature") || "",
          txnAmount: Number(queryParams.get("txnAmount")) || null,
          userEmail: queryParams.get("userEmail"),
          userPhone: queryParams.get("userPhone"),
          cartItems: cartItems?.items || [],
          txnDate: queryParams.get("txnDate"),
        });
      }
    };

    fetchTransactionData();
  }, [location.search]);

  const addHiddenField = (form, name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  const formatPrice = (price) => {
    const formattedPrice = price.toFixed(2);
    const finalPrice = formattedPrice.toLocaleString("en-QA");
    return finalPrice;
  };

  useEffect(() => {
    try {
      const {
        orderId,
        signature,
        txnAmount,
        userEmail,
        userPhone,
        txnDate,
        cartItems,
      } = transactionData;
      const signaturePayload = {
        CALLBACK_URL: `${API_BASE_URL}/transactions/callback`,
        EMAIL: userEmail || "",
        MOBILE_NO: userPhone || "",
        ORDER_ID: orderId || "",
        TXN_AMOUNT: Number(txnAmount),
        WEBSITE: WEBSITE,
        txnDate: txnDate || "",
        SADAD_WEBCHECKOUT_PAGE_LANGUAGE: "eng",
        merchant_id: "3389243", // "3191649",
      };
      const form = document.createElement("form");
      form.action = "https://sadadqa.com/webpurchase";
      form.method = "POST";

      Object.entries(signaturePayload).forEach(([key, value]) =>
        addHiddenField(form, key, value.toString())
      );
      addHiddenField(form, "signature", signature);

      cartItems.forEach((item, index) => {
        addHiddenField(
          form,
          `productdetail[${index}][order_id]`,
          item.productId._id
        );
        addHiddenField(
          form,
          `productdetail[${index}][amount]`,
          formatPrice(item.price).toString()
        );
        addHiddenField(
          form,
          `productdetail[${index}][quantity]`,
          item.quantity.toString()
        );
      });

      setTimeout(() => {
        document.body.appendChild(form);
        form.submit();
      }, 1000);
      // document.body.appendChild(form);
      // form.submit();
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  }, [transactionData]);

  return (
    <div id="loader">
      <div className="container">
        <div className="image"></div>
        <div className="progress">
          <div className="progress-bar">
            <div className="shimmer">
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutForm;
